import { useMemo } from "react";
import { useXpropsSelectedInstrument } from "./useXpropInstrument";

/**
 * Hook to get data needed for average based calculator
 * @returns {{
 *   lastPrice: number | null,
 *   instrumentId: number | null,
 *   currencyCode: string | null,
 *   loading: boolean,
 *   error: object | null
 * }}
 */
export const useAverageBasedCalculatorData = () => {
  const { selectedInstrument } = useXpropsSelectedInstrument();

  const data = useMemo(() => {
    // Use selectedInstrument from useInstrument hook which has the 'last' field
    if (!selectedInstrument) {
      return {
        lastPrice: null,
        instrumentId: null,
        currencyCode: null,
        loading: false,
        error: null,
      };
    }

    // Get last price from selected instrument
    // The 'last' field contains the current/last price
    const lastPrice = selectedInstrument.last || null;
    const instrumentId = selectedInstrument.instrumentId || null;
    const currencyCode = selectedInstrument.currencyCode || null;

    return {
      lastPrice,
      instrumentId,
      currencyCode,
      loading: false,
      error: null,
    };
  }, [selectedInstrument]);

  return data;
};

